import { render, staticRenderFns } from "./drawer-add-account.vue?vue&type=template&id=c45dcb9a&"
import script from "./drawer-add-account.vue?vue&type=script&lang=ts&"
export * from "./drawer-add-account.vue?vue&type=script&lang=ts&"
import style0 from "./drawer-add-account.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports